/* eslint-disable import/prefer-default-export */
import store from '@/store'
import { getData } from '@core/utils/http/general'

// get registro from node api
export const fillPlanes = (liberar = false) => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 17,
    token: store.state.cuenta.session.token,
    liberar,
  }
  getData(paramsRequest, 'wscompras')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) resolve(response.data.data)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

export const fillEstados = () => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 2,
  }
  getData(paramsRequest, 'wspublico')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) resolve(response.data.data)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

export const fillPeriodos = async plan => {
  const paramsRequest = {
    action: 21,
    plan,
  }
  const response = await getData(paramsRequest, 'wspublico')
  if (response.status === 204) return []

  if (response.status === 200 && response.data?.status === 200) {
    return response.data.periodos ?? []
  }

  return []
}
